import Vue from 'vue';
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import Panel from 'vux/src/components/panel/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'
import InlineCalendar from 'vux/src/components/inline-calendar/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Icon from 'vux/src/components/icon/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import TransferDomDirective from 'vux/src/directives/transfer-dom/index.js'


Vue.use(AlertPlugin);
Vue.use(ConfirmPlugin);
Vue.use(ToastPlugin, {position: 'middle', type: 'text'});
Vue.use(LoadingPlugin);

Vue.component('swiper', Swiper);
Vue.component('flexbox', Flexbox);
Vue.component('flexbox-item', FlexboxItem);
Vue.component('grid', Grid);
Vue.component('grid-item', GridItem);
Vue.component('group', Group);
Vue.component('cell', Cell);
Vue.component('cell-box', CellBox);
Vue.component('scroller', Scroller);
Vue.component('tab', Tab);
Vue.component('tab-item', TabItem);
Vue.component('cell-form-preview', CellFormPreview);
Vue.component('panel', Panel);
Vue.component('check-icon', CheckIcon);







// WEBPACK FOOTER //
// ./src/config/vue-prototype.js